import {useChatContext} from '../Context'
import NewChat from '../new-chat/Index'
import ViewChat from '../old-chat/Index'
import NoChat from '../no-chat/NoChat'

function ChatWindow() {
  const {chatWindowState} = useChatContext()

  switch (chatWindowState) {
    case 'no-chat':
      return <NoChat />
    case 'new-chat':
      return <NewChat />
    case 'view-chat':
      return <ViewChat />

    default:
      return <div>Unknown Chat window state</div>
  }
}

export default ChatWindow
